import { List, Typography, Descriptions, Divider, Alert, Table } from 'antd';
import ListUrlAction from "../../../../src/components/ListUrlAction";
import SelectVKA from "../../../../src/components/content/SelectVKA";
import SelectDOACIndicatie from "../../../../src/components/content/SelectDOACIndicatie";
import * as React from 'react';
export default {
  List,
  Typography,
  Descriptions,
  Divider,
  Alert,
  Table,
  ListUrlAction,
  SelectVKA,
  SelectDOACIndicatie,
  React
};